import PropTypes from "prop-types"
import { head } from "ramda"
import React from "react"
import str from "utils/strings"
import { isNotNullOrEmpty } from "../../utils/validate"
import withFormField from "../create-form-field"
import VSpace from "../layouts/v-space"
import TextInputBase from "./text-input-base"
import { ErrorMessage, FieldTitle, NoSpaceErrorMessage, Red, Root } from "./text-input.styles"

const TextInput = React.forwardRef(({
                                      title,
                                      value,
                                      placeholder,
                                      isRequired,
                                      onChange,
                                      error,
                                      disabled,
                                      readOnly,
                                      fieldState,
                                      noSpaceError = false,
                                      ariaText,
                                      ...rest
                                    }, ref) => {
  const { errors } = fieldState
  const errorMessage = isNotNullOrEmpty(errors) ? head(errors) : null
  const errorText = errorMessage && errorMessage !== "" ? `* ${str[errorMessage]}` : ""
  const inputProps = { value, placeholder, onChange, error: isNotNullOrEmpty(errors), disabled, readOnly, ariaText }
  return (
    <Root ref={ref} {...rest}>
      <Title title={title} isRequired={isRequired} />
      <TextInputBase {...inputProps} />
      <ErrorView noSpaceError={noSpaceError} errorText={errorText} />
    </Root>
  )
})

const ErrorView = ({ noSpaceError, errorText }) => (
  <>{(noSpaceError && <NoSpaceErrorMessage floatShow={errorText !== ""}>{errorText}</NoSpaceErrorMessage>) ||
    <ErrorMessage show={errorText !== ""}>{errorText}</ErrorMessage>}</>
)

const Title = ({ title, isRequired }) => (
  <>
    <FieldTitle>
      {title}
      {isRequired && <Red> *</Red>}
    </FieldTitle>
    <VSpace length={6} />
  </>
)

TextInput.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
  fieldState: PropTypes.object,
  noSpaceError: PropTypes.bool
}

TextInput.defaultProps = {
  title: "",
  isRequired: false,
  disabled: false,
  readOnly: false,
  fieldState: {},
  noSpaceError: false,
  onChange: () => {
  }
}

export default withFormField(TextInput)
